import * as React from "react";
import styles = require("./style.less");

interface InputLabelProps {
    label: string | JSX.Element;
}

const InputLabel: React.SFC<InputLabelProps> = (props) => {
    return <div className={styles.label}>
        {props.label}
    </div>;
};

export default InputLabel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/form/InputLabel/InputLabel.tsx